/**
 * Formats a string by replacing underscores with spaces and capitalizing each word
 * @param str The string to format (e.g., "sushi_restaurant")
 * @returns The formatted string (e.g., "Sushi Restaurant")
 */
export const formatRestaurantType = (str: string): string => {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}; 